import { Component, Inject, OnDestroy, OnInit } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";
import { CommonWorkflowStep, LoggingService } from "src/app/core";
import { ShowroomWorkflow, ShowroomWorkflowSource } from "../../../models";
import { ShowroomShortlistItem } from "../../models/showroom-shortlist-item";

const Workflow = ShowroomWorkflow.Shortlist;
const WorkflowSource = ShowroomWorkflowSource.ShowroomShortlistOverlayItemDialog;

@Component({
    selector: "app-showroom-shortlist-overlay-item-dialog",
    templateUrl: "./showroom-shortlist-overlay-item-dialog.component.html",
    styleUrls: ["./showroom-shortlist-overlay-item-dialog.component.scss"],
    standalone: false
})
export class ShowroomShortlistOverlayItemDialogComponent implements OnInit, OnDestroy {
  private _destroyed$: Subject<void> = new Subject();

  constructor(
    private _dialog: MatDialogRef<ShowroomShortlistOverlayItemDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: ShowroomShortlistItem,
    private _loggingService: LoggingService,
  ) {}

  ngOnInit(): void {
    this._loggingService.logWorkflow(
      "Showroom shortlist overlay item dialog component init",
      "ShowroomShortlistOverlayItemDialogComponent.ngOnInit",
      Workflow,
      CommonWorkflowStep.ComponentLoad,
      WorkflowSource,
    );

    this._dialog.disableClose = true;

    this._dialog
      .backdropClick()
      .pipe(takeUntil(this._destroyed$))
      .subscribe({ next: () => this._close(CommonWorkflowStep.ModalCloseBackdrop) });

    this._dialog
      .keydownEvents()
      .pipe(takeUntil(this._destroyed$))
      .subscribe({
        next: event => {
          if (event.key === "Escape") {
            this._close(CommonWorkflowStep.ModalCloseEsc);
          }
        },
      });
  }

  ngOnDestroy(): void {
    this._destroyed$.next();
    this._destroyed$.complete();
  }

  onCloseClick(): void {
    this._close(CommonWorkflowStep.ModalCloseX);
  }

  private _close(workflowStep: string): void {
    this._loggingService.logWorkflow(
      "Showroom shortlist overlay close",
      "ShowroomShortlistOverlayItemDialogComponent._close",
      Workflow,
      CommonWorkflowStep.ModalClose,
      WorkflowSource,
      {
        ModalCloseType: workflowStep,
      },
    );

    this._dialog.close();
  }
}
